import { ref } from 'vue';
import { trackBrandVideoPlayed } from '../analytics/events';

interface UseVideoTrackingOptions {
  brandUuid: string;
  displayContext?: string;
}

export function useVideoTracking(options: UseVideoTrackingOptions) {
  const hasTrackedPlay = ref(false);

  const trackPlay = (videoId: string) => {
    if (hasTrackedPlay.value || !videoId) {
      return;
    }

    hasTrackedPlay.value = true;

    trackBrandVideoPlayed({
      brand_uuid: options.brandUuid,
      video_id: videoId,
      display_context: options.displayContext,
    });
  };

  const resetTracking = () => {
    hasTrackedPlay.value = false;
  };

  return {
    hasTrackedPlay,
    trackPlay,
    resetTracking,
  };
}
